import { createContext, useContext } from 'react';
import {
  FlyoutContext as FlyoutContextType,
  FlyoutContextValue,
} from './flyout.types';

const FlyoutContext = createContext<FlyoutContextValue>(
  {} as FlyoutContextValue,
);

export const FlyoutProvider = ({ children, value }: FlyoutContextType) => (
  <FlyoutContext.Provider value={value}>{children}</FlyoutContext.Provider>
);

export const useFlyoutContext = () => useContext(FlyoutContext);
